<kendo-upload

[saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl"
  [autoUpload]="false"
  [multiple]="false"
  [restrictions]="_restrictions"
  (select)="_onSelect($event)">
</kendo-upload>
